import React from 'react'

const PartnerFaq = () => {
    return (
        <div className="_faq_nft_wrapper">
            <div className="_faq_nft_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12">
                            <div className="_faq_nft_head">
                                <h3 className="_faq_nft_head_txt">FAQs</h3>
                                <p className="_faq_nft_head_para">For more
                                    FAQs visit our partnership page in our help center</p>
                            </div>
                            <div className="_faq_nft_accord_wrap">
                                <div className="accordion" id="accordionPanelsStayOpenExample">
                                    <div className="accordion-item _item_space">
                                        <h6 className="accordion-header" id="panelsStayOpen-headingOne">
                                            <button className="accordion-button _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                                                whats a nFT, what makes them so great?
                                            </button>
                                        </h6>
                                        <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                                            <div className="accordion-body _faq_nft_accord_itm_cont">
                                                An NFT is a digital asset stored on the blockchain.
                                                These assets hold information, like descriptions,
                                                properties, and media files. NFTs are unique,
                                                one-of-a-kind, and non-interchangeable.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item _item_space">
                                        <h6 className="accordion-header" id="panelsStayOpen-headingTwo">
                                            <button className="accordion-button collapsed _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true" aria-controls="panelsStayOpen-collapseTwo">
                                                what makes all blocks special?
                                            </button>
                                        </h6>
                                        <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                                            <div className="accordion-body _faq_nft_accord_itm_cont">
                                                An NFT is a digital asset stored on the blockchain.
                                                These assets hold information,
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item _item_space">
                                        <h6 className="accordion-header" id="panelsStayOpen-headingThree">
                                            <button className="accordion-button collapsed _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="true" aria-controls="panelsStayOpen-collapseThree">
                                                what does a partnership with allblocks entail?
                                            </button>
                                        </h6>
                                        <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                                            <div className="accordion-body _faq_nft_accord_itm_cont">
                                                An NFT is a digital asset stored on the blockchain.
                                                These assets hold information,
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item _item_space">
                                        <h6 className="accordion-header" id="panelsStayOpen-headingFour">
                                            <button className="accordion-button collapsed _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true" aria-controls="panelsStayOpen-collapseFour">
                                                what does it cost to partner with oallblocks
                                            </button>
                                        </h6>
                                        <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
                                            <div className="accordion-body _faq_nft_accord_itm_cont">
                                                An NFT is a digital asset stored on the blockchain.
                                                These assets hold information,
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item _item_space">
                                        <h6 className="accordion-header" id="panelsStayOpen-headingFive">
                                            <button className="accordion-button collapsed _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="true" aria-controls="panelsStayOpen-collapseFive">
                                                how do we get started?
                                            </button>
                                        </h6>
                                        <div id="panelsStayOpen-collapseFive" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFive">
                                            <div className="accordion-body _faq_nft_accord_itm_cont">
                                                An NFT is a digital asset stored on the blockchain.
                                                These assets hold information,
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default PartnerFaq